import 'controllers/frontend';
import { Application } from "stimulus"
import StaticSearchController from "../controllers/home/static_search_controller"

const application = Application.start()
application.register("static-search", StaticSearchController)
// import 'alpinejs';

require('@rails/ujs').start();
require('turbolinks').start();
require('@rails/activestorage').start();
require('channels');
// eslint-disable-next-line import/extensions
require('custom/glidejs_custom.js');

const images = require.context('../images', true);
/* eslint-disable no-unused-vars */
const imagePath = (name) => images(name, true);

document.addEventListener('DOMContentLoaded', function () {
  setTimeout(function () {
    const toggle = document.getElementById('map_toggle');
    if (toggle && toggle.checked) {
      toggle.click();
    }
  }, 500); // Delay in milliseconds (500ms = 0.5 seconds)
});



window.initPlaces = function (...args) {
  const event = document.createEvent('Events');
  event.initEvent('google-maps-callback', true, true);
  event.args = args;
  window.dispatchEvent(event);
};
